"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = exports.TooltipContainer = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./Tooltip.pc.css");
const TooltipContainer = ({ className, inherit, inlineBlock, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_b8d6c9cb', '_62fa33a3', '_pub-62fa33a3', '_pub-3c25d522', {
            '_62fa33a3_inherit _pub-62fa33a3_inherit _pub-3c25d522_inherit inherit': inherit,
            '_62fa33a3_inline-block _pub-62fa33a3_inline-block _pub-3c25d522_inline-block inline-block': inlineBlock,
        }, className) }, children));
};
exports.TooltipContainer = TooltipContainer;
const Tooltip = ({ className, visible, center, left, narrow, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_56d8a8e7', '_62fa33a3', '_pub-62fa33a3', '_pub-3c25d522', '_62fa33a3_tooltip', '_pub-62fa33a3_tooltip', '_pub-3c25d522_tooltip', 'tooltip', {
            '_62fa33a3_visible _pub-62fa33a3_visible _pub-3c25d522_visible visible': visible,
            '_62fa33a3_center _pub-62fa33a3_center _pub-3c25d522_center center': center,
            '_62fa33a3_left _pub-62fa33a3_left _pub-3c25d522_left left': left,
            '_62fa33a3_narrow _pub-62fa33a3_narrow _pub-3c25d522_narrow narrow': narrow,
        }, className) }, children));
};
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map